import script from "./AdminPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminPage.vue?vue&type=script&setup=true&lang=ts"

import "./AdminPage.vue?vue&type=style&index=0&id=78bc42c2&lang=css"

const __exports__ = script;

export default __exports__